module.exports = __webpack_public_path__ + "static/media/espumadechapala.35aaf1d6.png";